import * as React from "react";
import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
import { 
  SearchFilters,
 } from "../../../types/v1_schemas";
 import {
  optionWithId,
  getLookupOptions
} from "../../../types/lookup";
import FilterCheckbox from "./FilterCheckbox";
import AppAlert from "../../AppAlert";
import { useTranslation } from "react-i18next";
import { ReactComponent as Phone } from "../../../images/phone.svg";
import { toggleItemInFilterList } from "../../../utils/filters/shared";


type TypeOfHelpInputProps = {
  legend: string;
  compact?: boolean;
  showAllOptions?: boolean;
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};

function TypeOfHelpInput({
  legend,
  compact = false,
  showAllOptions = false,
  filters,
  setFilters,
}: TypeOfHelpInputProps) {
  const { t } = useTranslation();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [typeOfHealthOptions, settypeOfHealthOptions] = useState(() => getLookupOptions("serviceCategory"));
  
  const setServiceCategoryFilter = (serviceCategory: optionWithId) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "type of help",
      filter_type: "type of help",
      filter_value: t("typeOfHelpShortValues" + serviceCategory.translate),
    });
    setFilters({
      ...filters,
      serviceCategoryIds: toggleItemInFilterList(
        filters.serviceCategoryIds as any[], 
        serviceCategory.id.toString()
        ) as [],
    });
  };

  return (
    <Fieldset legend={legend} legendStyle={compact ? "srOnly" : "large"}>
      {typeOfHealthOptions.filter(function(obj:optionWithId) {return showAllOptions || (obj.lineageText !== "None" && obj.lineageText !== "Unknown");}).map((option:optionWithId) => (
        <React.Fragment key={option.lineageText}>
          <FilterCheckbox
            name={option.id.toString()}
            value={option.id.toString()}
            label={t(`typeOfHelpValues${option.translate}`)}
            selectedFilterValues={filters.serviceCategoryIds ?? []}
            onChange={() => setServiceCategoryFilter(option)}
            key={option.id.toString()}
          />

          {option.lineageText === "Crisis services" && 
            filters.serviceCategoryIds?.includes(option.id.toString()) && (
              <div className="margin-y-2" id="crisis-content-box">
                <AppAlert Icon={Phone}>
                  <div>{t("suicidalIdeationAlert")}</div>
                  <div className="text-bold margin-top-1">
                    {t("suicidalIdeationCta")}
                  </div>
                </AppAlert>
              </div>
            )}
        </React.Fragment>
      ))}
    </Fieldset>
  );
}

export default TypeOfHelpInput;
